<kendo-dialog *ngIf="assignFormActive" (close)="closeAssignForm()" [width]="600">
  <kendo-dialog-titlebar>
    <h3>{{ 'ASSIGN-TASK' | translate }}</h3>
  </kendo-dialog-titlebar>
  <form novalidate [formGroup]="assignForm" class="k-form">
    <div class="row">
      <div class="col-12">
        <span class="k-text-uppercase dark">
          {{'TASKS' | translate}}
        </span>
        <kendo-multiselect class="w-100" [data]="tasksMember" formControlName="tasks" [textField]="'name'"
          [filterable]="false" [valueField]="'id'" [autoClose]="true">
          <ng-template kendoMultiSelectItemTemplate let-dataItem>
            <div class="m-1">
              <input type="checkbox" [checked]="isTaskAssigned('tasks', dataItem.id)" kendoCheckBox />
              <label class="k-checkbox-label">{{ dataItem.name }}</label>
            </div>
          </ng-template>
        </kendo-multiselect>
      </div>
    </div>
  </form>
  <kendo-dialog-actions>
    <button class="k-button" (click)="onCancel($event)">{{ 'CANCEL' | translate }}</button>
    <button appPreventClick class="k-button k-primary" (click)="onSave($event)">{{
      'ASSIGN' | translate }}</button>
  </kendo-dialog-actions>
</kendo-dialog>